import React, {Fragment, useEffect, useState} from "react";
import {getUser} from "../../utils/user";
import {hasUser} from "../../utils/cookies";
import './email_notification.scss';
import useNotification from "../notification/notification";
import Button from "@mui/material/Button/Button";
import {resendConfirmEmail} from "../../redux/user/requests";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useSnackbar} from "notistack";
import {useLocation} from "react-router-dom";

let snackbarKey = null;
const EmailVerificationNotification = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const location = useLocation(); // << get current location
    const loggedCondition = hasUser();
    const userSession = getUser();
    const [, sendNotification] = useNotification();
    const NOTIFICATION_DELAY = 500;
    const [notificationDisplayed, setNotificationDisplayed] = useState(false);

    const excludedPaths = [
        '/',
        '/subscriptions',
        '/confirm-email',
        '/get-started',
        '/confirm-free',
        '/logout/',
        '/subscriptions/',
        '/confirm-email/',
        '/get-started/',
        '/confirm-free/',
        '/voucher/',
        '/terms-of-use',
        '/privacy-policy',
        '/home',
        '/about-us',
    ]; // add more if needed

    const resendEmail = () => {
        closeSnackbar(snackbarKey);
        resendConfirmEmail().then((r) => {
            if(r.data['success']){
                sendNotification({
                    msg: 'Email sent!',
                    variant: 'success'
                });
            }else{
                sendNotification({
                    msg: 'An error occurred, please try again later or contact system admin',
                    variant: 'error',
                    autoHideDuration: 3000
                });
                setTimeout(() => {
                    displayEmailNotification();
                }, NOTIFICATION_DELAY)
            }
        }).catch(() => {
            sendNotification({
                msg: 'An error occurred, please try again later or contact system admin',
                variant: 'error',
                autoHideDuration: 3000
            });
            setTimeout(() => {
                displayEmailNotification();
            }, NOTIFICATION_DELAY)
        }).finally(() => {
        })
    }

    const MESSAGE = (
        <p className="color-white margin-left-20 text-center margin-bottom-0 margin-top-0">
            In order to start your free trial you will need to verify your email.
            <br />
            Didn't get the email?
            <br />
            <Button
                variant="text"
                color="white"
                onClick={resendEmail}
                className="color-white"
                size="xs">
                Resend Verification
            </Button>
        </p>
    );
    const variant = 'warning';
    const autoHideDuration = 500000;
    const action = (key) => {
        return <Fragment>
            <IconButton onClick={() => { closeSnackbar(key) }} style={{color:'white'}}>
                <CloseIcon />
            </IconButton>
        </Fragment>
    };

    const displayEmailNotification = () => {
        // notification for the user to verify his email
        snackbarKey = enqueueSnackbar(MESSAGE, {
            variant,
            autoHideDuration,
            preventDuplicate: true,
            action
        });
    }

    useEffect(() => {
        const userSession = getUser();
        if (loggedCondition && userSession && !userSession['email_confirmed']) {

            if (!excludedPaths.includes(location.pathname)) {
                console.log('can show it now');
                displayEmailNotification();
                setNotificationDisplayed(true);
            } else {
                if (notificationDisplayed) {
                    closeSnackbar(snackbarKey);
                    setNotificationDisplayed(false);
                }
            }
        } else {
            // if user confirmed, close any previous snackbar
            if (notificationDisplayed) {
                closeSnackbar(snackbarKey);
                setNotificationDisplayed(false);
            }
        }
    }, [location.pathname]); // << rerun on every location/path change

    useEffect(() => {
        const handleUserRefreshed = () => {
            const updatedUser = getUser();
            if (updatedUser && updatedUser['email_confirmed']) {
                closeSnackbar(snackbarKey);
                setNotificationDisplayed(false);
            }
            if(updatedUser === null){
                //logout case:
                closeSnackbar(snackbarKey);
                setNotificationDisplayed(false);
            }
        };

        // Listen for user refresh after email confirm
        document.addEventListener('user_refreshed', handleUserRefreshed);

        return () => {
            document.removeEventListener('user_refreshed', handleUserRefreshed);
        };

    },[]);

    return null
}

export default EmailVerificationNotification;
